import { Box } from "@outschool/backpack";
import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useSession } from "@outschool/ui-auth";
import { CurvedGradientSection } from "@outschool/ui-legacy-component-library";
import React from "react";

import ClassCarousels from "../ClassCarousels";

type DefaultBelowClassDetailProps = {
  otherListingsRef: React.MutableRefObject<null>;
  moreLikeThisRef: React.MutableRefObject<null>;
  activity: ClassDetailsNoSectionsQuery["activity"];
  leader: ClassDetailsNoSectionsQuery["activity"]["leader"];
  isRestricted: boolean;
  randomPopularCategories?: {
    title: string;
    basePath?: string;
    slug?: string;
  }[];
};
export const DefaultBelowClassDetail = ({
  otherListingsRef,
  moreLikeThisRef,
  activity,
  leader,
  isRestricted,
  randomPopularCategories,
}: DefaultBelowClassDetailProps) => {
  const { currentUser } = useSession();

  return (
    <CurvedGradientSection>
      <Box
        ref={otherListingsRef}
        sx={{
          minHeight: "500px",
        }}
      >
        <ClassCarousels
          activity={activity}
          leader={leader}
          currentUser={currentUser}
          moreLikeThisRef={moreLikeThisRef}
          isRestricted={isRestricted}
          randomPopularCategories={randomPopularCategories}
        />
      </Box>
    </CurvedGradientSection>
  );
};
